<template>
  <div class="page-container">
    
  </div>
</template>

<script>
export default {
  name: 'about',
  components: {
  },
  data() {
    return {
    }
  },
  components: {
  },
  mounted() {
  },

  setup() {
  }
}
</script>

<style>

</style>
